// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Order_item_requests_UploadPhotoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for POST /so/order_item_requests/upload_photo
 *
 * Returns the uploaded photo URL (`{url: string}`) — Azure blob URL
 * when available, otherwise a base_url() fallback path under
 * `uploads/so/order-item-requests/`.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Order_item_requests_UploadPhotoResponseDados {
url: string
}

export type Order_item_requests_UploadPhotoResponse = ApiResponse<Order_item_requests_UploadPhotoResponseDados>;

registerResponseContract('Order_item_requests_UploadPhotoResponse', {
  url: { type: 'string',  required: true },
})
